import React from "react";

import asIcon from "./asIcon";

export default asIcon(({ color }) => (
  <g fill={color}>
    <path d="M94 83.9L66 50.6l-.2-.1-.2.1-11.8 9.9-.1.2.1.2 28 33.3.2.1.2-.1L94 84.3l.1-.2-.1-.2zM60.7 63.4c-1.1 0-1.9-.9-1.9-1.9s.9-1.9 1.9-1.9 1.9.9 1.9 1.9-.8 1.9-1.9 1.9zm3.9 5.1c-1.1 0-1.9-.9-1.9-1.9s.9-1.9 1.9-1.9 1.9.9 1.9 1.9-.9 1.9-1.9 1.9zm1.3-9c-1.1 0-1.9-.9-1.9-1.9s.9-1.9 1.9-1.9c1.1 0 1.9.9 1.9 1.9s-.9 1.9-1.9 1.9zm3.8 5.2a1.9 1.9 0 1 1 0-3.8c1 0 1.9.9 1.9 1.9 0 1-.8 1.9-1.9 1.9zm12.5 21.7a3.2 3.2 0 0 1-3.2-3.2c0-1.8 1.4-3.2 3.2-3.2 1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2z" />
    <path d="M53.5 73.6l-1.4-4.2h6.4L52.3 62c-.4-.5-.6-1.1-.5-1.7s.3-1.2.8-1.5L64.4 49c.5-.4 1.1-.6 1.7-.5.6.1 1.2.3 1.5.8l16.1 19.2c.8-.7 1.3-1.7 1.3-2.8V26.4c0-2.1-1.7-3.8-3.8-3.8H18.9a3.8 3.8 0 0 0-3.8 3.8v39.2c0 2.1 1.7 3.8 3.8 3.8h30.8l-1.4 4.2H36.2a1.9 1.9 0 1 0 0 3.8h28.1l.8-.2-3.1-3.6h-8.5z" />
  </g>
));
